import { render, staticRenderFns } from "./Silbensuche.vue?vue&type=template&id=1fb3bec6"
import script from "./Silbensuche.vue?vue&type=script&lang=ts"
export * from "./Silbensuche.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports